export default {
  styleOverrides: {
    root: {
      '& .MuiButtonBase-root': {
        margin: '0 3px',
      },
    },
  },
};
